import React from 'react'
import './contactPage.scss'

export default function MessageSent(){
  return(
    <div className="contact-page-container">
      <div className="contact-page">
        <div className="contact-page-title">
          Your question has been sent!
        </div>
        <div className="contact-page-sent-message">
          TIP: Be on the lookout for a call or email from a dealership team member.
          If you do not receive any communication, you may want to check your spam folder!
        </div>
      </div>
    </div>
  )
}
